<template>
    <div class="wrapper">
        <el-table
                :data="jsonDataList"
                stripe
                style="width: 100%">
            <el-table-column
                    prop="id"
                    label="id"
                    width="100"
            >
            </el-table-column>
            <el-table-column
                    prop="templ_name"
                    label="模板名称"
                    >
            </el-table-column>
            <el-table-column
                    prop="remarks"
                    label="备注"
            >
            </el-table-column>
            <el-table-column
                    prop="created_time"
                    label="创建时间"
                    >
                <template slot-scope="scope">
                     <span>{{filtersMoment(scope.row.created_time)}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    fixed="right"
                    label="操作"
                    width="200"
                   >
                <template slot-scope="scope">
                    <el-button @click="checkDetail(scope.row)" type="text" size="small">查看</el-button>
                    <el-button  @click="updateTemplate(scope.row)" type="text" size="small">编辑</el-button>
                    <el-button  @click="deleteTemplate(scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
      <!--  <div id="printMe"> <fm-generate-form
                :data="jsonData"
                :remote="remoteFuncs"
                :value="values"
                ref="generateForm">
        </fm-generate-form> </div>-->
<!--        &lt;!&ndash;startprint&ndash;&gt;
        <div id="printMe">?221321
            <div v-html='text'></div>
        </div>
        &lt;!&ndash;endprint&ndash;&gt;
   &lt;!&ndash;    -->
        <el-dialog :center="true" :fullscreen="true" title="预览" :visible.sync="dialogVisible">
            <el-switch
                    @change="changeMethod"
                    v-model="pcOrM"
                    active-color="#13ce66"
                    active-text="pc"
                    inactive-text="手机"
                    inactive-color="rgb(0, 126, 255)">
            </el-switch>
            <div v-if="pcOrM == false" style="width:475px;height:797px;background: url(../iphone6.png);background-repeat: no-repeat;background-size:475px 797px; margin: 0 auto;">
                <div class="myformMaking" style="width: 378px;
    height: 577px;position: relative;
    top: 108px;
    overflow-y:auto;
    left: 49px;
background-color: #ffffff">
                    <fm-generate-form
                            :data="jsonData"
                            :remote="remoteFuncs"
                            :value="values"
                            ref="generateForm">
                    </fm-generate-form>
                </div>
            </div>
            <div v-if="pcOrM == true">
                <div style="background-color: #ffffff;height: 700px;margin-top: 15px;overflow-y:auto;">
                    <fm-generate-form
                            :data="jsonData"
                            :remote="remoteFuncs"
                            :value="values"
                            ref="generateForm">
                    </fm-generate-form>
                </div>

            </div>
        </el-dialog>
    </div>
</template>

<script>
    // import 'form-making/dist/FormMaking.less'
    import moment from '../../node_modules/moment/src/moment.js';
    import gql from 'graphql-tag';
    export default {
        name: '',
        data() {
            return {
                pcOrM:true,
                jsonData:{},
                jsonDataList:[
                    {
                        name:'22',
                        data:{
                        "list": [
                            {
                                "type": "time",
                                "icon": "icon-time",
                                "options": {
                                    "defaultValue": "",
                                    "readonly": false,
                                    "disabled": false,
                                    "editable": true,
                                    "clearable": true,
                                    "placeholder": "",
                                    "startPlaceholder": "",
                                    "endPlaceholder": "",
                                    "isRange": false,
                                    "arrowControl": true,
                                    "format": "HH:mm:ss",
                                    "required": false,
                                    "width": "",
                                    "remoteFunc": "func_1581265391000_46974"
                                },
                                "name": "时间选择器",
                                "key": "1581265391000_46974",
                                "model": "time_1581265391000_46974",
                                "rules": []
                            },
                            {
                                "type": "rate",
                                "icon": "icon-pingfen1",
                                "options": {
                                    "defaultValue": 0,
                                    "max": 5,
                                    "disabled": false,
                                    "allowHalf": false,
                                    "required": false,
                                    "remoteFunc": "func_1581265392000_30867"
                                },
                                "name": "评分",
                                "key": "1581265392000_30867",
                                "model": "rate_1581265392000_30867",
                                "rules": []
                            },
                            {
                                "type": "slider",
                                "icon": "icon-slider",
                                "options": {
                                    "defaultValue": 0,
                                    "disabled": false,
                                    "required": false,
                                    "min": 0,
                                    "max": 100,
                                    "step": 1,
                                    "showInput": false,
                                    "range": false,
                                    "width": "",
                                    "remoteFunc": "func_1581265394000_23813"
                                },
                                "name": "滑块",
                                "key": "1581265394000_23813",
                                "model": "slider_1581265394000_23813",
                                "rules": []
                            }
                        ],
                        "config": {
                            "labelWidth": 100,
                            "labelPosition": "right",
                            "size": "small"
                        }
                        }
                    }
                ],

                values: {}, // 表单需要显示的表单数据
                remoteFuncs: {
                    // 组件配置时配置的远端方法,保持和配置时输入的名称一致
                    func_test (resolve) {
                        // 模拟接口请求
                        setTimeout(() => {
                            const options = [
                                {id: '1', name: '1111'},
                                {id: '2', name: '2222'},
                                {id: '3', name: '3333'}
                            ]

                            // 获取到的值和标签可以通过配置页远端配置
                            // 值:id  标签：name
                            resolve(options) // 将后端获取的数据放入回调函数中
                        }, 2000)
                    },

                },
                templateValue:"",
                dialogVisible:false,
                info:"信息",
                text:"<div>测试文字{{info}}</div>",
                printObjT:{
                    id: "printMe",
                    popTitle: 'good print',
                    extraCss: 'https://www.baidu.com',
                    extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
                },
                pageNumber:1,
                pageSize:10,
                requestParams:
                    `
          count
          data{
              id
              team_id
              doctor_id
              templ_name
              remarks
              templ_content
              created_time
              update_time
          }`,
            }
        },
        methods: {
            filtersMoment(time) {
                return (moment(time).format('YYYY-MM-DD HH:mm:ss'));
            },
            changeMethod(val){
                console.log(val)
            },
           async deleteTemplate(row){

               this.$confirm('此操作将永久删除该模板, 是否继续?', '提示', {
                   confirmButtonText: '确定',
                   cancelButtonText: '取消',
                   type: 'warning'
               }).then(async() => {
                   try {
                       await this.$apollo.mutate({
                           mutation: gql`mutation(
                                      $id: Int!
                                    ){
                                      removeTemplate(
                                        id: $id
                                      )
                                    }`,
                           variables: {
                               id: row.id
                           },
                       });
                       this.$message({
                           message: "删除成功!",
                           type: "success"
                       });

                       this.pageNumber = 1;
                       this.pageSize = 10
                       this.init();
                   }catch (e) {
                       this.$message.error(error.message.split(":")[1]);
                   }
               }).catch((err) => {
                   console.log(err)
               });


            },
            updateTemplate(row){
                this.$router.push({
                    name: 'templateSetting',
                    params:{template:row}
                });
            },
            checkDetail(row){
                try {
                    this.jsonData = JSON.parse(row.templ_content)
                    this.dialogVisible = true;
                }catch (e) {
                    this.$message.error("请确认正确的模板格式");
                }


            },
           async init(){
                const response = await this.$apollo.query({
                    query: gql`{
                    templateInfo(page_number:${this.pageNumber},page_size:${this.pageSize}){
                        ${this.requestParams}
                    }
                }`,
                    fetchPolicy: 'no-cache',
                });
               this.jsonDataList = response.data.templateInfo.data
            }
        },
        mounted() {
           this.init();
        }
    }
</script>
<!--<style lang="less" scoped>
    @import '../assets/style/FormMaking.less';
</style>-->

<style lang="less" scoped>
    .wrapper {
        width: 100%;
        height: calc(100% - 40px);

        .item {
            margin-top: 20px;
        }

        .item-head {
            display: flex;
            height: 36px;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #55a9c6;

            .til {
                color: #47a2bf;
                padding-left: 5px;
                font-size: 14px;
                font-weight: bold;
            }

            .save-btn {
                width: 80px;
                height: 20px;
                color: #fff;
                border-radius: 5px;
                background-color: #47a2bf;
                text-align: center;
                line-height: 20px;
                font-size: 12px;
                cursor: pointer;
            }
        }

        .parameter-list {
            .list-item {
                padding-left: 5px;
                margin-top: 10px;

                .list-til {
                    display: inline-block;
                    width: 100px;
                    font-size: 14px;
                    font-weight: bold;
                }

                input {
                    width: 270px;
                    height: 30px;
                    border: 1px solid #bbb;
                    border-radius: 5px;
                    text-indent: 10px;
                    outline: none;
                }
            }
        }
    }
</style>
